module.exports = __webpack_public_path__ + "img/eagleEye0tel.b298b77c.png";